import React from "react";
import "./PrintRotationTest.css";

export default function PrintRotationTest() {
  return (
    <div className="print-container">
      <div className="horizontal-layout">
        <div className="item">A</div>
        <div className="item">B</div>
        <div className="item">C</div>
        <div className="item">D</div>
        <div className="item">E</div>
      </div>
    </div>
  );
}
